import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import carousel1 from "../images/carousel1.jpg";
import carousel2 from "../images/carousel2.jpg";
import carousel3 from "../images/carousel3.jpg";
import carousel4 from "../images/carousel4.jpg";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";

const CarouselComponent = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const useStyles = makeStyles((theme) => ({
    carousel_style: {
      height: 700,
      width: "100%",
    },
  }));

  const classes = useStyles();

  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={carousel1}
          alt="First slide"
          className={classes.carousel_style}
        />
        <Carousel.Caption>{/* <h3>First slide label</h3> */}</Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={carousel2}
          alt="Second slide"
          className={classes.carousel_style}
        />

        <Carousel.Caption>{/* <h3>Second slide label</h3> */}</Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={carousel4}
          alt="Third slide"
          className={classes.carousel_style}
        />

        <Carousel.Caption>{/* <h3>Third slide label</h3> */}</Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={carousel3}
          alt="Fourth slide"
          className={classes.carousel_style}
        />

        <Carousel.Caption>{/* <h3>Third slide label</h3> */}</Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
};

export default CarouselComponent;
